// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"coaches_scrollbar__oSzuo"};